<template>
  <div>
    <div class="statistics-wrap">
      <div class="stat-item-full">
        <div>
          <div class="stat-item-full-label">使用总算力</div>
          <div class="stat-item-full-value">{{ usetotal.power_total || 0 }}</div>
        </div>
        <div class="stat-item-full-icon">⚡</div>
      </div>
      <template v-for="item in statisticTypes">
        <div class="stat-item" :style="`background: ${item.bg}; border: 1px solid ${item.border};color:${item.color}`" :key="item.value">
          <div class="stat-label">
            <span class="stat-icon" v-if="item.icon">{{item.icon}}</span>
            <span >{{ item.label }}</span>
          </div>
          <div class="stat-value">
            {{ usetotal[item.totalKey] == null ? 0 : usetotal[item.totalKey] }}
          </div>
        </div>
      </template>

    </div>
    <div class="custom-el-wrapper">
      <div class="search-wrap custom-form-wrap">
        <el-form inline size="mini" :model="searchParams" :rules="formRules" ref="searchForm">
          <el-form-item label="统计日期：" prop="statistics_at"
                        :rules="[{ required: true, message: '请选择费用日期', trigger: 'change' }]">
            <template slot="label">
              统计日期
              <el-tooltip class="item" effect="dark" content="统计时间从2026年7月1号开始" placement="top">
                <i class="el-icon-question" style="margin-left: 5px; cursor: pointer;"></i>
              </el-tooltip>
            </template>
            <el-date-picker v-model="searchParams.statistics_at" type="daterange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                            :picker-options="search_pickerOptions" clearable style="width: 240px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="searchParams.use_type" clearable placeholder="使用类型" class="w200">
              <el-option label="使用" :value="1"></el-option>
              <el-option label="退回" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺分组：">
            <el-select class="w200" v-model="searchParams.group_id" placeholder="全部分组" clearable multiple
                       collapse-tags filterable>
              <el-option v-for="item in shopgroupList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="商品主分组：">
            <el-select class="w200" v-model="searchParams.product_group_id" placeholder="全部分组" clearable multiple
                       collapse-tags filterable @change="handleProductGroupChange">
              <el-option v-for="item in productgroupList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="商品子分组：">
            <el-select class="w200" v-model="searchParams.product_child_group_id" placeholder="全部子分组" clearable multiple
                       collapse-tags filterable>
              <el-option v-for="item in productChildGroupList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-form inline size="mini" style="margin: 10px 0 12px">
          <el-form-item label="使用类型：">
            <div class="search-wrap-tabs">
              <div class="search-tabs-item" v-for="item in statisticTypes" :key="item.value" :style="searchParams.direction_type.includes(item.value)?`background: ${item.bg}; border: 1px solid ${item.border};color:${item.color}`:''" @click="changeType(item)">
                <span v-if="searchParams.direction_type.includes(item.value)">✓ </span>
                <span>{{item.label}}</span>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div style="flex: 1;text-align: right">
          <el-button class="btn"  @click="handleReset()">重置</el-button>
          <el-button class="btn btn--primary" @click="handleSearch(1)">查询</el-button>
        </div>
      </div>
      <div class="table-page-wrapper">
        <div class="custom-table-wrap">
          <el-table :data="tableData" style="width: 100%" v-loading="loading" :key="random + 1">
            <el-table-column label="统计时间" prop="statistics_at">
              <template #default="{row}">
                <span style="color: #6a6a8a;font-size: 11px">{{row.statistics_at}}</span>
              </template>
            </el-table-column>
            <el-table-column label="使用类型" prop="direction_type_name" align="center">
              <template #default="{row}">
                <span class="type-tag" :style="getDirectionTypeStyle(row.direction_type)">{{ getDirectionTypeName(row.direction_type) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="店铺分组名称" prop="shop_group_name" align="center" width="140">
              <template slot-scope="scope">
                <span v-if="scope.row.direction_type === 4">
                  <span v-if="scope.row.shop_group_id === 0 || !scope.row.shop_group_id">未分组</span>
                  <span v-else>{{ getGroupName(scope.row.shop_group_id, shopgroupList) }}</span>
                </span>
                <span v-else style="color: #c0c4cc;">—</span>
              </template>
            </el-table-column>
            <el-table-column label="商品主分组名称" prop="product_group_name" align="center" width="140">
              <template slot-scope="scope">
                <span v-if="[1, 2, 3, 8].includes(scope.row.direction_type)">
                  <span v-if="scope.row.product_group_id === 0 || !scope.row.product_group_id">未分组</span>
                  <span v-else>{{ getGroupName(scope.row.product_group_id, productgroupList) }}</span>
                </span>
                <span v-else style="color: #c0c4cc;">—</span>
              </template>
            </el-table-column>
            <el-table-column label="商品子分组名称" prop="product_child_group_name" align="center" width="140">
              <template slot-scope="scope">
                <span v-if="[1, 2, 3, 8].includes(scope.row.direction_type)">
                  <span v-if="scope.row.product_child_group_id === 0 || !scope.row.product_child_group_id">未分组</span>
                  <span v-else>{{ getGroupName(scope.row.product_child_group_id, allProductGroupList) }}</span>
                </span>
                <span v-else style="color: #c0c4cc;">—</span>
              </template>
            </el-table-column>
            <el-table-column label="使用状态" prop="use_type_name" align="center">
              <template #default="{row}">
                <span class="type-tag type-tag--round" :class="row.use_type === 1 ? 'type-tag--green' : 'type-tag--red'">{{ row.use_type === 1 ? '成功' : '退回' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="使用量" prop="use_num" align="center">
              <template #default="{row}">
                <span class="use-num">{{row.use_num ||0}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page-wrap">
          <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" :page-sizes="[10, 20, 50, 100, 200]" @pagination="getList"  layout="total, sizes, prev, pager, next, jumper" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Pagination from "@/components/newUi/Pagination.vue";
export default {
  components: {Pagination},
  data() {
    return {
      loading: false,
      random: 0,
      page_data: {
        limit: 10,
        page: 1,
        total: 0,
      },
      tableData: [],
      searchParams: {
        use_type: '',
        direction_type: [],
        group_id: [],
        product_group_id: [],
        product_child_group_id: [],
        statistics_at: [],
      },
      shopgroupList: [],
      productgroupList: [],
      productChildGroupList: [],
      allProductGroupList: [],
      search_pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date('2026-06-30').getTime() || time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
            end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
            end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
            end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      formRules: {
        statistics_at: [{ required: true, message: '请选择费用日期', trigger: 'change' }]
      },
      usetotal: {
        power_total: 0,
        ai_image_power_total: 0,
        ai_sku_power_total: 0,
        ai_title_power_total: 0,
        quota_total:0,
        ai_img_power_total:0,
      },
      statisticsCanPrev: false,
      statisticsCanNext: false,
      statisticTypes: [
        { value: 1, label: '图片检测算力', totalKey: 'ai_image_power_total',color:'#c8443c',bg:'#fff5f5',border:'#ffccc7',icon:'🖼️' },
        { value: 8, label: 'sku检测算力', totalKey: 'sku_price_power_total',color:'#0d9488',bg:'rgb(13, 148, 136, 0.1)',border:'rgba(13, 148, 136, 0.3)',icon:'🔄' },
        { value: 2, label: 'sku替换算力', totalKey: 'ai_sku_power_total',color:'#fb923c',bg:'#fff7e6',border:'#ffd591',icon:'✍️' },
        { value: 3, label: 'AI标题算力', totalKey: 'ai_title_power_total',color:'#722ed1',bg:'rgba(114, 46, 209, 0.1)',border: 'rgba(114, 46, 209, 0.3)',icon:'🎨' },
        { value: 5, label: 'AI生成图片算力', totalKey: 'ai_img_power_total',color:'#1677ff',bg:'#e6f4ff',border:'#91caff',icon:'📦' },
        { value: 4, label: '使用铺货算力', totalKey: 'quota_total',color:'#52c41a',bg:'#f6ffed',border:'#b7eb8f' },

      /*  { value: 5, label: 'AI白底图', totalKey: 'ai_white_power_total' },
        { value: 6, label: 'AI3:4图', totalKey: 'ai_three_to_four_power_total' },
        { value: 7, label: 'AI视频', totalKey: 'ai_video_power_total' },
        { value: 10, label: 'AI常规白底图', totalKey: 'ai_regular_white_power_total' },
        { value: 9, label: 'AI商品标记', totalKey: 'ai_product_mark_power_total' },*/
      ],
    }
  },
  created() {
    this.loadGroupList()
  },
  mounted() {

  },
  methods: {
    ...mapActions({
      getShopBoardGroupList: "shop_board/getShopBoardGroupList",
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      opGetGroupStatisticsList: 'ucenter/opGetGroupStatisticsList',
    }),
    init(){
      this.setDefaultDateRange()
      this.getList()
    },
    // 获取列表数据
    getList() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          this.loading = true
          let param = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
          const aiImgKeys=['ai_white_power_total','ai_three_to_four_power_total','ai_video_power_total','ai_regular_white_power_total']
           if(param.direction_type.includes('ai_img_power_total')){
             param.direction_type=param.direction_type.concat(aiImgKeys)
             delete param.ai_img_power_total
           }
          // 获取统计分组列表
          this.opGetGroupStatisticsList({
            data: param,
            success: (res) => {
              this.loading = false
              if (res.code === 200) {
                this.tableData = res.data.list || []
                this.page_data.total = res.data.total || 0;
                this.usetotal = { ...this.usetotal, ...(res.data.usetotal || {}) }
                aiImgKeys.forEach(key=>{
                  this.usetotal.ai_img_power_total+=Number(res.data?.[key]??0)
                })
              } else {
                this.$message.error(res.message || '获取分组统计信息失败');
              }
            }
          })
        } else {
          return false
        }
      })

    },
    handleSizeChange(val){
      this.page_data.limit=val
      this.page_data.page=1
      this.getList()
    },
    handleCurrentChange(val){
      this.page_data.page=val
      this.getList()
    },
    getGroupName(groupId, groupList) {
      if (!groupId || groupId === 0) {
        return '-';
      }
      const group = groupList.find(item => item.id === groupId);
      return group ? group.name : '分组已删除';
    },
    getDirectionTypeName(directionType) {
      const item = this.statisticTypes.find(type => type.value === Number(directionType));
      return item ? item.label : '-';
    },
    getDirectionTypeStyle(directionType) {
      const item = this.statisticTypes.find(type => type.value === Number(directionType));
      return item ?`background: ${item.bg}; border: 1px solid ${item.border};color:${item.color}`:'';
    },

    // 搜索
    handleSearch(page) {
      this.page_data.page = page || 1
      this.getList()
    },

    // 重置
    handleReset() {
      this.searchParams = {
        use_type: '',
        direction_type: [],
        group_id: [],
        product_group_id: [],
        product_child_group_id: [],
        statistics_at: [],
      }
      this.productChildGroupList = []
      this.setDefaultDateRange()
      this.handleSearch(1)
    },

    //切换使用类型
    changeType(row){
      const index = this.searchParams.direction_type.findIndex(i=>row.value==i)
      if(index>-1){
        this.searchParams.direction_type.splice(index,1)
      }else{
        this.searchParams.direction_type.push(row.value)
      }
    },

    handleProductGroupChange() {
      if (!this.searchParams.product_group_id || this.searchParams.product_group_id.length === 0) {
        this.productChildGroupList = [];
        this.searchParams.product_child_group_id = [];
        return;
      }

      const childGroupsMap = new Map();
      this.searchParams.product_group_id.forEach(parentId => {
        const parent = this.allProductGroupList.find(g => g.id === parentId);
        if (parent && parent.child_groups && Array.isArray(parent.child_groups)) {
          parent.child_groups.forEach(child => {
            childGroupsMap.set(child.id, child);
          });
        }
      });

      this.productChildGroupList = Array.from(childGroupsMap.values());

      if (this.searchParams.product_child_group_id.length > 0) {
        const validChildIds = childGroups.map(c => c.id);
        this.searchParams.product_child_group_id = this.searchParams.product_child_group_id.filter(id =>
          validChildIds.includes(id)
        );
      }
    },

    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.shopgroupList = res.data || [];
          } else {
            this.$message.error(res.message || '获取分组失败');
          }
        }
      })

      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) {
            const groups = res.data || [];
            this.allProductGroupList = groups;
            this.productgroupList = groups.filter(g => !g.parent_id || g.parent_id === 0);
          } else {
            this.$message.error(res.message || '获取商品分组失败');
          }
        }
      })
    },
    setDefaultDateRange() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      this.searchParams.statistics_at = [
        this.formatDate(start),
        this.formatDate(end)
      ];
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  }
}
</script>
<style scoped>

.w200 {
  width: 200px;
}
.statistics-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 16px;
}

.stat-item {
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 4px;
}

.stat-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 500;
}
.stat-icon{
  font-size: 16px;
}


.stat-value {
  font-family: "JetBrains Mono", monospace;
  font-size: 18px;
  font-weight: 700;
}

.stat-item-full{
  grid-column: 1 / -1;
  border-radius: 8px;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: rgba(200, 68, 60, 0.2) 0px 2px 12px;
}
.stat-item-full-label{
  color: #ffffff;
  margin-bottom: 4px;
}
.stat-item-full-value{
  font-family: "JetBrains Mono", monospace;
  font-size: 26px;
  font-weight: 800;
  color: rgb(255, 255, 255);
}
.stat-item-full-icon{
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.search-wrap {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.search-wrap-tabs{
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.search-tabs-item{
  height: 26px;
  line-height: 26px;
  padding: 0px 12px;
  border-radius: 13px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: rgb(106, 106, 138);
  background: rgb(245, 245, 245);
  border: 1px solid rgb(224, 224, 236);
  transition: 0.15s;
}
.table-page-wrapper{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.custom-table-wrap{
  border-radius: 0;
}
.custom-table-wrap :deep(.el-table td.el-table__cell){
  font-size: 12px;
  color: rgb(26, 26, 46);
}
.page-wrap{
  padding: 10px 14px;
  background: rgb(245, 240, 232);
}
.type-tag{
  padding: 2px 8px;
  border-radius: 4px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  font-weight: 500;
}
.type-tag--round {
  padding: 2px 9px;
  border-radius: 10px;
  font-weight: 600;
}
.type-tag--green{
  background: rgb(246, 255, 237);
  border: 1px solid rgb(183, 235, 143);
  color: rgb(82, 196, 26);
}
.type-tag--red{
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color:rgb(200, 68, 60);
}
.use-num{
  font-size: 13px;
  font-weight: 700;
  color: rgb(22, 119, 255)
}

</style>
